import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider } from '@/contexts/AuthContext';
import api from '@/lib/api';
import MapPage from '@/pages/MapPage';
import AuthCallback from '@/pages/AuthCallback';
import SupabaseCallback from '@/pages/SupabaseCallback';
import AdminPage from '@/pages/AdminPage';
import ModerationPage from '@/pages/ModerationPage';
import StaticPage from '@/pages/StaticPage';
import TutorialPage from '@/pages/TutorialPage';
import AddToHomeBanner from '@/components/AddToHomeBanner';
import '@/App.css';

function AppRouter() {
  useEffect(() => {
    let vid = localStorage.getItem('ca_visitor_id');
    if (!vid) {
      vid = (crypto?.randomUUID && crypto.randomUUID()) || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem('ca_visitor_id', vid);
    }
    api.post('/track-visit', { visitor_id: vid, path: window.location.pathname }).catch(() => {});
  }, []);

  // OAuth code is handled at the dedicated /auth/google route below.
  return (
    <Routes>
      <Route path="/" element={<MapPage />} />
      <Route path="/auth/callback" element={<SupabaseCallback />} />
      <Route path="/auth/google" element={<AuthCallback />} />
      <Route path="/about" element={<StaticPage type="about" />} />
      <Route path="/tutorial" element={<TutorialPage />} />
      <Route path="/contact" element={<StaticPage type="contact" />} />
      <Route path="/privacy" element={<StaticPage type="privacy" />} />
      <Route path="/terms" element={<StaticPage type="terms" />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/admin/users" element={<AdminPage initialTab="users" />} />
      <Route path="/admin/moderation" element={<ModerationPage />} />
      <Route path="*" element={<MapPage />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <AddToHomeBanner />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}
